export const BlockSegmentsOnlyUsersFlag = 'tempDashboardBlockSegmentsOnlyUsers231123';
